import {createAction} from 'redux-act';

export const GET_BYOC_VIRTUAL_NUMBERS = createAction(
  'byocVirtualNumbers/GET_BYOC_VIRTUAL_NUMBERS'
);
export const GET_BYOC_VIRTUAL_NUMBERS_SUCCESS = createAction(
  'byocVirtualNumbers/GET_BYOC_VIRTUAL_NUMBERS_SUCCESS'
);
export const GET_BYOC_VIRTUAL_NUMBERS_FAILURE = createAction(
  'byocVirtualNumbers/GET_BYOC_VIRTUAL_NUMBERS_FAILURE'
);

export const CREATE_BYOC_VIRTUAL_NUMBER = createAction(
  'byocVirtualNumbers/CREATE_BYOC_VIRTUAL_NUMBER'
);
export const CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS = createAction(
  'byocVirtualNumbers/CREATE_BYOC_VIRTUAL_NUMBER_SUCCESS'
);
export const CREATE_BYOC_VIRTUAL_NUMBER_FAILURE = createAction(
  'byocVirtualNumbers/CREATE_BYOC_VIRTUAL_NUMBER_FAILURE'
);

export const UPDATE_BYOC_VIRTUAL_NUMBER = createAction(
  'byocVirtualNumbers/UPDATE_BYOC_VIRTUAL_NUMBER'
);
export const UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS = createAction(
  'byocVirtualNumbers/UPDATE_BYOC_VIRTUAL_NUMBER_SUCCESS'
);
export const UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE = createAction(
  'byocVirtualNumbers/UPDATE_BYOC_VIRTUAL_NUMBER_FAILURE'
);

export const GET_LOCATION_OTTER_BRANDS = createAction(
  'byocVirtualNumbers/GET_LOCATION_OTTER_BRANDS'
);
export const GET_LOCATION_OTTER_BRANDS_SUCCESS = createAction(
  'byocVirtualNumbers/GET_LOCATION_OTTER_BRANDS_SUCCESS'
);
export const GET_LOCATION_OTTER_BRANDS_FAILURE = createAction(
  'byocVirtualNumbers/GET_LOCATION_OTTER_BRANDS_FAILURE'
);
export const CLEAR_LOCATION_OTTER_BRANDS = createAction(
  'byocVirtualNumbers/CLEAR_LOCATION_OTTER_BRANDS'
);

export const DELETE_BYOC_VIRTUAL_NUMBER = createAction(
  'byocVirtualNumbers/DELETE_BYOC_VIRTUAL_NUMBER'
);
export const DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS = createAction(
  'byocVirtualNumbers/DELETE_BYOC_VIRTUAL_NUMBER_SUCCESS'
);
export const DELETE_BYOC_VIRTUAL_NUMBER_FAILURE = createAction(
  'byocVirtualNumbers/DELETE_BYOC_VIRTUAL_NUMBER_FAILURE'
);

export const SEARCH_ACTIVE_LOCATIONS = createAction(
  'byocVirtualNumbers/SEARCH_ACTIVE_LOCATIONS'
);
export const SEARCH_ACTIVE_LOCATIONS_SUCCESS = createAction(
  'byocVirtualNumbers/SEARCH_ACTIVE_LOCATIONS_SUCCESS'
);
export const SEARCH_ACTIVE_LOCATIONS_FAILURE = createAction(
  'byocVirtualNumbers/SEARCH_ACTIVE_LOCATIONS_FAILURE'
);
export const CLEAR_ACTIVE_LOCATIONS = createAction(
  'byocVirtualNumbers/CLEAR_ACTIVE_LOCATIONS'
);

export const PAGE_CHANGE = createAction('byocVirtualNumbers/PAGE_CHANGE');
export const SEARCH_CHANGE = createAction('byocVirtualNumbers/SEARCH_CHANGE');
export const CLEAR_FILTERS = createAction('byocVirtualNumbers/CLEAR_FILTERS');
